/**
 * 封装 axios 请求模块
 */
import axios from "axios"

const request = axios.create({
  // baseURL: "http://www.shenyangcubeassociation.org.cn/service",   // 基础路径
  // baseURL: "http://192.168.1.51:8080",   // ly
  // baseURL: "http://192.168.1.7:8888",   // yd
  baseURL: "http://www.cubeassociation.net/prod-api/"// 基础测试路径,
  // timeout: 10000
})

export default request
